// extracted by mini-css-extract-plugin
export default {"rating":"WH-z","numberOfStars":"XH-z","count":"YH-z","barGraphSpacing":"ZH-z","barGraph":"_H-z"};